import { render, staticRenderFns } from "./TableTop.vue?vue&type=template&id=45991bc2&scoped=true&"
import script from "./TableTop.vue?vue&type=script&lang=js&"
export * from "./TableTop.vue?vue&type=script&lang=js&"
import style0 from "./TableTop.vue?vue&type=style&index=0&id=45991bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45991bc2",
  null
  
)

export default component.exports